import { render, staticRenderFns } from "./SecurityformsForm.vue?vue&type=template&id=005da504"
import script from "./SecurityformsForm.vue?vue&type=script&lang=js"
export * from "./SecurityformsForm.vue?vue&type=script&lang=js"
import style0 from "./SecurityformsForm.vue?vue&type=style&index=0&id=005da504&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports